<div class="custom_icon_btn">
  <fa-icon [icon]="icon"></fa-icon>
  <span>{{label | translate}}</span>
</div>
